// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KrZZ5htyB5V6_j5vKSwo {
    height: var(--track-height);
    width: 2rem;
    background: var(--p-color-icon-secondary);
    padding: 0.25rem;
    box-shadow: inset 0 0.0625rem 0.25rem rgba(0, 0, 0, 0.05);
    border: none;
    border-radius: 0.375rem;
    cursor: pointer;
    transition: background var(--p-motion-duration-50) var(--p-motion-ease);
  }
  
  .KrZZ5htyB5V6_j5vKSwo:after {
    content: '';
    position: absolute;
    z-index: 1;
    top: -0.0625rem;
    right: -0.0625rem;
    bottom: -0.0625rem;
    left: -0.0625rem;
    display: block;
    pointer-events: none;
    box-shadow: 0 0 0 -0.0625rem var(--p-color-border-focus);
    transition: box-shadow var(--p-motion-duration-100) var(--p-motion-ease);
    border-radius: calc(var(--p-border-radius-100) + 0.0625rem);
  }
  
  .tIYEuTZ2YbgaNP_2RXqN {
    background: var(--p-color-bg-inverse);
  }
  
  .pXGRhs2oxKmVvdNc5_v8 {
    height: 0.75rem;
    width: 0.75rem;
    border-radius: 0.1875rem;
    background: var(--p-color-bg-surface);
    transition: transform var(--p-motion-duration-50) var(--p-motion-ease);
  }
  
  .ThQiGssGR3KLp7GyO2cv {
    transform: translate(100%);
  }
  
  .KrZZ5htyB5V6_j5vKSwo:hover {
    background: rgba(97, 97, 97, 1);
  }
  
  .tIYEuTZ2YbgaNP_2RXqN:hover {
    background: rgba(48, 48, 48, 1);
  }
  `, "",{"version":3,"sources":["webpack://./src/styles/Toggle.module.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,WAAW;IACX,yCAAyC;IACzC,gBAAgB;IAChB,yDAAyD;IACzD,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,uEAAuE;EACzE;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,wDAAwD;IACxD,wEAAwE;IACxE,2DAA2D;EAC7D;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,eAAe;IACf,cAAc;IACd,wBAAwB;IACxB,qCAAqC;IACrC,sEAAsE;EACxE;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,+BAA+B;EACjC","sourcesContent":[".track {\r\n    height: var(--track-height);\r\n    width: 2rem;\r\n    background: var(--p-color-icon-secondary);\r\n    padding: 0.25rem;\r\n    box-shadow: inset 0 0.0625rem 0.25rem rgba(0, 0, 0, 0.05);\r\n    border: none;\r\n    border-radius: 0.375rem;\r\n    cursor: pointer;\r\n    transition: background var(--p-motion-duration-50) var(--p-motion-ease);\r\n  }\r\n  \r\n  .track:after {\r\n    content: '';\r\n    position: absolute;\r\n    z-index: 1;\r\n    top: -0.0625rem;\r\n    right: -0.0625rem;\r\n    bottom: -0.0625rem;\r\n    left: -0.0625rem;\r\n    display: block;\r\n    pointer-events: none;\r\n    box-shadow: 0 0 0 -0.0625rem var(--p-color-border-focus);\r\n    transition: box-shadow var(--p-motion-duration-100) var(--p-motion-ease);\r\n    border-radius: calc(var(--p-border-radius-100) + 0.0625rem);\r\n  }\r\n  \r\n  .track_on {\r\n    background: var(--p-color-bg-inverse);\r\n  }\r\n  \r\n  .knob {\r\n    height: 0.75rem;\r\n    width: 0.75rem;\r\n    border-radius: 0.1875rem;\r\n    background: var(--p-color-bg-surface);\r\n    transition: transform var(--p-motion-duration-50) var(--p-motion-ease);\r\n  }\r\n  \r\n  .knob_on {\r\n    transform: translate(100%);\r\n  }\r\n  \r\n  .track:hover {\r\n    background: rgba(97, 97, 97, 1);\r\n  }\r\n  \r\n  .track_on:hover {\r\n    background: rgba(48, 48, 48, 1);\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"track": `KrZZ5htyB5V6_j5vKSwo`,
	"track_on": `tIYEuTZ2YbgaNP_2RXqN`,
	"knob": `pXGRhs2oxKmVvdNc5_v8`,
	"knob_on": `ThQiGssGR3KLp7GyO2cv`
};
export default ___CSS_LOADER_EXPORT___;
